// Префикс ключа `GET /api/matches` (ключи `$api` — `[method, path, init]`).
// Список показывает статус разбора, поэтому его перечитывают после запуска и окончания разбора.
export const MATCH_LIST_QUERY_KEY = ["get", "/api/matches"] as const;
